import { makeObservable, observable, action } from 'mobx';
import dayjs from 'dayjs';
import { dataAccess } from 'ts/core/dataAccess/dataAccess';
import globalStore from '../../../store/Global';
import { DATE_FORMAT } from 'ts/constants/constants';

export interface ICommit {
  hash: string;
  date: string;
  message: string;
  branch: string;
  added: number;
  removed: number;
  url: string;
  project: IProjectRepository;
  repository: IProjectRepository;
}

interface IProjectRepository {
  id: number;
  name: string;
}

export interface IProject {
  name: string;
  time: number;
}

export interface ITogglData {
  projects?: IProject[];
  total: number;
  warning?: string;
}

export interface IGitStatisticsStore {
  commitsList: ICommit[];
  togglData: any;
  setCommitsList: () => void;
  setTogglData: () => void;
}

class GitStatisticsStore implements IGitStatisticsStore {
  commitsList: ICommit[] = [];
  togglData: ITogglData | null = null;

  constructor() {
    makeObservable(this, {
      commitsList: observable,
      togglData: observable,
      setCommitsList: action,
    });
  }

  async setCommitsList() {
    const { contributorId, dateRange } = globalStore;
    if (!dateRange) {
      const [commitsList] = await dataAccess.getAllCommits(contributorId ?? '');
      this.commitsList = commitsList;
    } else {
      const [dateFrom, dateTo] = dateRange;
      if (dateFrom && dateTo) {
        const [commitsList] = await dataAccess.getSpecificCommits(
          contributorId ?? '',
          dayjs(dateFrom).format(DATE_FORMAT),
          dayjs(dateTo).format(DATE_FORMAT)
        );
        this.commitsList = commitsList;
      }
    }
  }

  async setTogglData() {
    const { contributorId, dateRange } = globalStore;
    if (!dateRange) {
      const [togglData] = await dataAccess.getTogglTotals(
        contributorId ?? '',
        '',
        ''
      );
      this.togglData = togglData;
    } else {
      const [dateFrom, dateTo] = dateRange;
      if (dateFrom && dateTo) {
        const [togglData] = await dataAccess.getTogglTotals(
          contributorId ?? '',
          dayjs(dateFrom).format(DATE_FORMAT),
          dayjs(dateTo).format(DATE_FORMAT)
        );
        this.togglData = togglData;
      }
    }
  }
}

const gitstatStore = new GitStatisticsStore();

export default gitstatStore;
